import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import Dashboard from './pages/Dashboard';
import Investors from './pages/Investors';
import SalesLeads from './pages/SalesLeads';
import Recruitment from './pages/Recruitment';
import Contacts from './pages/Contacts';
import { CRMProvider } from './context/CRMContext';

function App() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <CRMProvider>
      <Router>
        <div className="flex h-screen bg-gray-50">
          <Sidebar isOpen={sidebarOpen} onToggle={() => setSidebarOpen(!sidebarOpen)} />
          
          <div className="flex-1 flex flex-col overflow-hidden">
            <main className="flex-1 overflow-x-hidden overflow-y-auto bg-gray-50">
              <div className="container mx-auto px-6 py-8">
                <Routes>
                  <Route path="/" element={<Dashboard />} />
                  <Route path="/investors" element={<Investors />} />
                  <Route path="/sales-leads" element={<SalesLeads />} />
                  <Route path="/recruitment" element={<Recruitment />} />
                  <Route path="/contacts" element={<Contacts />} />
                </Routes>
              </div>
            </main>
          </div>
        </div>
      </Router>
    </CRMProvider>
  );
}

export default App;